export default function updateCoursePages() {
    // inject course title into courses page
    // SkillJar does not provide this functionality by default
    let pageArea = document.querySelector('#catalog-content');
    let courseHeader = document.createElement('h1');
    let courseTitle = document.querySelector('title');

    courseHeader.innerText = courseTitle.innerText;
    pageArea.prepend(courseHeader);
};
